import React from 'react';
import { useTranslation } from 'react-i18next';
import TableResultsSummary from './table-results-summary';

function MemberStatusResultsSummary({ active = 0, nominated = 0, total = 0 }) {
  const { t } = useTranslation();

  return (
    <TableResultsSummary count={total}>
      {' '}
      |
      <span>
        {t('common-active-users')}: <span>{active}</span>
      </span>{' '}
      |
      <span>
        {t('common-nominated-users')}: <span>{nominated}</span>
      </span>
    </TableResultsSummary>
  );
}

export default MemberStatusResultsSummary;
